import { Chip, Stack, Typography } from "../../components";

export const MergeInfoBlock = (props: {
  value: number | undefined;
  label: string | undefined;
  addCount?: number | undefined;
}) => {
  return (
    <Stack position="relative" spacing="sm" alignItems={"center"}>
      {props.addCount !== undefined && (
        <Chip
          label={<>+{props.addCount}</>}
          sx={{ position: "absolute", top: -10, right: 0 }}
          size="small"
          color={props.addCount > 0 ? "success" : undefined}
        />
      )}

      <Typography variant="h5">{props.value}</Typography>

      <Typography>{props.label}</Typography>
    </Stack>
  );
};
